import type { ZIndexScale } from '@/theme/types'

export const zIndex: ZIndexScale = {
  dropdown: 1300,
  modal: 1400,
  tooltip: 1500,
  overlay: 1200,
}

